import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Center,
  CloseButton,
  Flex,
  Grid,
  SimpleGrid,
  Stack,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Textarea,
  useColorModeValue,
  useTheme,
  VStack,
  Input
} from "@chakra-ui/react";

import { CertificateRepository, FileType, HeaderContext, } from "api/CertificateRepository";
import Card from "components/card/Card";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Dropzone from "views/admin/Certificate/Certificate Upload/Dropzone";
import { set } from "zod";

export default function NewProduct() {
  const navigate = useNavigate();
  const location = useLocation();
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const theme = useTheme();
  const fontcolor = useColorModeValue("black", "white")

  // Alert states
  const [centerAlertVisible, setCenterAlertVisible] = useState(false);
  const [centerAlertStatus, setCenterAlertStatus] = useState<"success" | "error">("success");
  const [centerAlertMessage, setCenterAlertMessage] = useState("");
  const today = new Date().toISOString().split("T")[0];
  const todayDate = new Date().toISOString();

  const showCenterAlert = (
    msg: string,
    status: "success" | "error" = "error",
    timeout = 4000
  ) => {
    setCenterAlertMessage(msg);
    setCenterAlertStatus(status);
    setCenterAlertVisible(true);
    setTimeout(() => setCenterAlertVisible(false), timeout);
  };

  // Form states
  const [orgId, setOrgId] = useState("");
  const [assetId, setAssetId] = useState("");
  const [vendorId, setVendorId] = useState("");
  const [locationId, setLocationId] = useState("");
  const [calibrationId, setCalibrationId] = useState("");
  const [certificateName, setCertificateName] = useState("");
  const [selectedCertificate, setSelectedCertificate] = useState<string | null>(null);
  const [discription, setDiscription] = useState("");
  const [headerContext, setHeaderContext] = useState<HeaderContext | null>(null);
  const [userId] = useState<string | null>(() => localStorage.getItem("jwt"));
  const [calibrationName, setCalibrationName] = useState("");
  const [status, setStatus] = useState("");
  const [existingCertificates, setExistingCertificates] = useState<FileType[]>([]);
  const [calibrationDate, setCalibrationDate] = useState("");
  const [calibrationDueDate, setCalibrationDueDate] = useState("");
  const [nextCalibrationDueDate, setNextCalibrationDueDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [calibrationFrequency, setCalibrationFrequency] = useState("");
  //const [otherFiles, setOtherFiles] = useState<(File | null)[]>([]);
  const [NoOfCertificates, setNoOfCertificates] = useState(5);
  const extraOthersCount = Math.max(0, NoOfCertificates - 5);
  const typeMapping: Record<string, number> = {
    Callibration: 0,
    Tracability: 1,
    Invoice: 2,
    ServiceReport: 3,
    Others: 4,
  };
  const certificateLabels = [
    "Upload Cali Certificate",
    "Traceability",
    "Invoice",
    "Service Report",
  ];

  const [files, setFiles] = useState<(File | null)[]>([]);

  const handleFileSelect = (index: number, file: File | null) => {
    console.log(index, file);

    setFiles((prev) => {
      const updated = [...prev];
      updated[index] = file;
      return updated;
    });
  };

  const getExistingFile = (type: string) => {
    const typeNumber = typeMapping[type];

    const cert = existingCertificates.find((c) =>
      c.type === type || Number(c.type) === typeNumber
    );

    if (!cert) return "";

    return cert.fileUrl || cert.fileName || "";
  };

  // Fetch Calibration data 
  useEffect(() => {
    const id = location.state?.id || null;
    if (id) {
      handleCalibrationChange(id);
      setCalibrationId(id);
    } else {
      showCenterAlert("No calibration ID provided!", "error");
    }

  }, [location.state?.id]);

  useEffect(() => {
    if (!calibrationDueDate || !calibrationFrequency) return;

    const date = new Date(calibrationDueDate);

    switch (calibrationFrequency.toLowerCase()) {
      case "monthly":
        date.setMonth(date.getMonth() + 1);
        break;

      case "quarterly":
        date.setMonth(date.getMonth() + 3);
        break;

      case "yearly":
        date.setFullYear(date.getFullYear() + 1);
        break;

      default:
        break;
    }

    const formattedDate = date.toISOString().split("T")[0];
    setNextCalibrationDueDate(formattedDate);

  }, [calibrationDueDate, calibrationFrequency]);

  // Fetch calibration & header context
  const handleCalibrationChange = async (id: string) => {
    try {
      const calibrationData = await CertificateRepository.getCalibrationById(id);

      setOrgId(calibrationData.orgId || "");
      setAssetId(calibrationData.assetId || "");
      setVendorId(calibrationData.vendorId || "");
      setLocationId(calibrationData.locationId || "");
      setCalibrationName(calibrationData.calibrationName || "");
      setStatus(calibrationData.status || "");
      setCalibrationDueDate(calibrationData.calibrationDueDate || "");
      setCalibrationFrequency(calibrationData.calibrationFrequency || "");
      setNoOfCertificates(Number(calibrationData.noOfCertificates || 5));
      console.log("Calibration Data:", calibrationData);
      console.log("Number of Certificates:", calibrationData.noOfCertificates);
      const headerData = await CertificateRepository.getHeaderContext(
        calibrationData.orgId || "",
        calibrationData.locationId || "",
        calibrationData.assetId || "",
        calibrationData.vendorId || "",
        calibrationData.departmentId || ""
      );
      setHeaderContext(headerData);

      const response = await CertificateRepository.getCertificatesByCalibrationId(id);
      const normalizedCertificates =
        Array.isArray(response?.certificates)
          ? response.certificates
          : Array.isArray(response?.data?.certificates)
            ? response.data.certificates
            : [];
      setExistingCertificates(normalizedCertificates);

      if (normalizedCertificates.length > 0) {
        const certificateId = response?.certificateId || response?.data?.certificateId || null;
        setSelectedCertificate(certificateId);
      } else {
        setSelectedCertificate(null);
      }
    } catch (error) {
    }
  };

  const handleUpdate = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      const formData = new FormData();

      formData.append("uploadedAt", new Date().toISOString());

      formData.append(
        "calibrationDate",
        calibrationDate
          ? new Date(calibrationDate).toISOString()
          : todayDate
      );

      formData.append(
        "nextCalibrationDueDate",
        nextCalibrationDueDate
          ? new Date(nextCalibrationDueDate).toISOString()
          : todayDate
      );

      files.forEach((file, index) => {
        if (!file) return;

        formData.append("files", file);

        if (index === 0) formData.append("types", "Callibration");
        else if (index === 1) formData.append("types", "Tracability");
        else if (index === 2) formData.append("types", "Invoice");
        else if (index === 3) formData.append("types", "ServiceReport");
        else formData.append("types", "Others");
      });

      if (formData.getAll("files").length === 0) {
        showCenterAlert("Please upload at least one file.", "error");
        return;
      }

      await CertificateRepository.updateCertificate(
        selectedCertificate,
        formData
      );

      showCenterAlert("Certificate updated successfully!", "success");

      setTimeout(() => {
        navigate("/admin/Calibration/calibrationRecord");
      }, 1200);

    } catch (err: any) {
      showCenterAlert(
        err?.message || "Failed to update certificate",
        "error"
      );
    } finally {
      setIsSubmitting(false);
    }
  };


  // Submit form
  const handleSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const formData = new FormData();
      formData.append("orgId", orgId);
      formData.append("assetId", assetId);
      formData.append("assetName", headerContext?.assetInfo?.name || "");
      formData.append("VendorName", headerContext?.vendorInfo?.name || "");
      formData.append("calibrationId", calibrationId);
      formData.append("certificateName", certificateName);
      formData.append("vendorId", vendorId);
      formData.append("locationId", locationId);
      formData.append("uploadedAt", new Date().toISOString());
      formData.append("createdAt", new Date().toString());
      formData.append("uploadedBy", new Date().toString());
      formData.append("userId", userId || "");
      formData.append("discription", discription);
      formData.append(
        "calibrationDate",
        calibrationDate
          ? new Date(calibrationDate).toISOString()
          : todayDate
      );

      formData.append(
        "nextCalibrationDueDate",
        nextCalibrationDueDate
          ? new Date(nextCalibrationDueDate).toISOString()
          : todayDate
      );
      files.forEach((file, index) => {
        if (!file) return;

        formData.append("files", file);

        if (index === 0) formData.append("types", "Callibration");
        else if (index === 1) formData.append("types", "Tracability");
        else if (index === 2) formData.append("types", "Invoice");
        else if (index === 3) formData.append("types", "ServiceReport");
        else formData.append("types", "Others");
      });
      if (formData.getAll("files").length === 0) {
        showCenterAlert("Please upload at least one file.", "error");
        setIsSubmitting(false);
        return;
      }

      await CertificateRepository.uploadCertificate(formData);
      showCenterAlert("Certificate uploaded successfully!", "success");

      setTimeout(() => {
        navigate("/admin/Calibration/calibrationRecord");
      }, 1200);
    } catch (error) {
      const msg =
        (error as any)?.message ||
        "Failed to upload certificate. Please try again.";
      showCenterAlert(msg, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Flex
      direction="column"
      minH="100vh"
      overflow="hidden"
      align="center"
      justify="flex-start"
      pt={{ sm: "125px", lg: "75px" }}
      position="relative"
    >
      {/* Centered Alert */}
      {centerAlertVisible && (
        <Center
          position="fixed"
          top="0"
          left="0"
          right="0"
          bottom="0"
          zIndex={60}
          pointerEvents="none"
        >
          <Alert
            status={centerAlertStatus}
            variant="solid"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            textAlign="center"
            width="600px"
            borderRadius="14px"
            boxShadow="xl"
            py={10}
            px={16}
            pointerEvents="auto"
          >
            <AlertIcon boxSize="40px" mr={0} />

            <Text fontSize="lg" fontWeight="700" mt={1}>
              {centerAlertMessage}
            </Text>
          </Alert>
        </Center>
      )}

      {/* Background Gradient */}
      <Box
        h="50vh"
        bgGradient="linear(to-b, brand.400, brand.600)"
        position="absolute"
        w="100%"
        borderRadius="20px"
      />

      {/* Header Context */}
      <Box w={{ sm: "330px", md: "700px", lg: "900px" }} mt={{ md: "30px" }} zIndex={2}>
        <Grid templateColumns="repeat(4, 1fr)" gap="20px">
          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue("white", "gray.700")} shadow="md" align="start">
            <Text fontWeight="bold" textAlign="center" w="100%">Organization</Text>
            <Text fontSize="sm" >Name: {headerContext?.orgInfo?.name || "_"}</Text>
            <Text fontSize="sm" >Contact: {headerContext?.orgInfo?.contact || "_"}</Text>
            <Text fontSize="sm" >GSTIN: {headerContext?.orgInfo?.gsTin || "_"}</Text>
          </VStack>

          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue("white", "gray.700")} shadow="md" align="start">
            <Text fontWeight="bold" textAlign="center" w="100%">Plant</Text>
            <Text fontSize="sm" >Name: {headerContext?.locationInfo?.name || "_"}</Text>
            <Text fontSize="sm" >City: {headerContext?.locationInfo?.city || "_"}</Text>
            <Text fontSize="sm" >State: {headerContext?.locationInfo?.state || "_"}</Text>
          </VStack>

          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue("white", "gray.700")} shadow="md" align="start">
            <Text fontWeight="bold" textAlign="center" w="100%">Asset</Text>
            <Text fontSize="sm" overflowWrap="break-word">Name: {headerContext?.assetInfo?.name || "_"}</Text>
            <Text fontSize="sm" >EQP ID : {headerContext?.assetInfo?.assetEquipmentId || "_"}</Text>
            <Text fontSize="sm" >Type: {headerContext?.assetInfo?.type || "_"}</Text>
            <Text fontSize="sm" >Status: {headerContext?.assetInfo?.status || "_"}</Text>
          </VStack>

          <VStack p={4} borderWidth="1px" borderRadius="md" bg={useColorModeValue("white", "gray.700")} shadow="md" align="start">
            <Text fontWeight="bold" textAlign="center" w="100%">Vendor</Text>
            <Text fontSize="sm" >Name : {headerContext?.vendorInfo?.name || "_"}</Text>
            <Text fontSize="sm" >Contact : {headerContext?.vendorInfo?.contactNumber || "_"}</Text>
            <Text fontSize="sm" >GSTIN : {headerContext?.vendorInfo?.gsTin || "_"}</Text>
          </VStack>
        </Grid>
      </Box>

      {/* Tabs Section */}
      <Tabs variant="unstyled" mt={{ base: "50px", md: "70px" }} zIndex={2} display="flex" flexDirection="column">
        <TabPanels maxW={{ md: "90%", lg: "100%" }} mx="auto">
          <TabPanel w={{ sm: "330px", md: "700px", lg: "850px" }} p="0px" mx="auto">
            <Card p="30px" maxH="80vh" overflow="auto">
              <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">
                Certificate Upload Details
                <CloseButton float="right" size="lg" onClick={() => navigate("/admin/Calibration/calibrationRecord")} />
              </Text>

              <Flex direction="column" w="100%">
                <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>Calibration</Text>
                      <Text fontSize="md" >
                        {calibrationName || "Loading..."}
                      </Text>
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>Status</Text>
                      <Text fontSize="md" >
                        {status || "Loading..."}
                      </Text>
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}> Calibration Date</Text>
                      <Text fontSize="md">
                        {calibrationDueDate
                          ? calibrationDueDate.split("T")[0]
                          : "Loading..."}
                      </Text>
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>calibration Frequency</Text>
                      <Text fontSize="md">
                        {calibrationFrequency || "Loading..."}
                      </Text>
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>New Calibration Date</Text>

                      <Input
                        type="date"
                        color={fontcolor}
                        value={calibrationDate || today}
                        min={today}
                        onChange={(e) => setCalibrationDate(e.target.value)}
                      />
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>Next Calibration Due Date</Text>
                      <Input
                        type="date"
                        color={fontcolor}
                        value={nextCalibrationDueDate || today}
                        min={today}
                        onChange={(e) => setNextCalibrationDueDate(e.target.value)}
                      />
                      {/* <Input type="date" readOnly color={fontcolor} value={nextCalibrationDueDate} /> */}
                    </Flex>
                  </Stack>

                  <Stack direction="column" gap="20px">
                    <Flex direction="column">
                      <Text fontWeight="bold" mb={2}>Description</Text>
                      <Textarea
                        placeholder="Enter description..."
                        value={discription}
                        onChange={(e) => setDiscription(e.target.value)}
                      />
                    </Flex>
                  </Stack>


                </SimpleGrid>

                {/* Upload Section */}
                <Card p="30px" mt={4}>
                  <Text color={textColor} fontSize="2xl" fontWeight="700" mb="20px">Upload Certificate</Text>
                  <Flex wrap="wrap" gap={4}>
                    {Array.from({ length: NoOfCertificates }).map((_, index) => (
                      <Dropzone
                        key={index}
                        label={
                          index < certificateLabels.length
                            ? certificateLabels[index]
                            : `Others ${index - certificateLabels.length + 1}`
                        }
                        onFileSelect={(file) => handleFileSelect(index, file)}
                        existingFile={
                          index === 0
                            ? getExistingFile("Callibration")
                            : index === 1
                              ? getExistingFile("Tracability")
                              : index === 2
                                ? getExistingFile("Invoice")
                                : index === 3
                                  ? getExistingFile("ServiceReport")
                                  : getExistingFile("Others")
                        }
                      />
                    ))}
                  </Flex>
                  <Flex justify="center" mt="24px">
                    <Button
                      variant="darkBrand"
                      fontSize="sm"
                      borderRadius="16px"
                      w={{ base: "100px", md: "150px" }}
                      h="46px"
                      onClick={handleSubmit}
                      isDisabled={existingCertificates.length > 0 || isSubmitting}
                      isLoading={isSubmitting}
                    >
                      Submit
                    </Button>
                    <Button variant="solid" colorScheme="cyan" fontSize="sm" borderRadius="16px" w={{ base: "100px", md: "150px" }} h="46px" mx={2} onClick={handleUpdate} isDisabled={existingCertificates.length === 0 || isSubmitting}>
                      update
                    </Button>
                  </Flex>
                </Card>
              </Flex>
            </Card>
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Flex>
  );
}
